module.exports = __webpack_public_path__ + "static/img/adduser1.d47c0b50.png";